module.exports = __webpack_public_path__ + "img/dialog-bg.582907e3.png";